import { FunctionComponent } from 'react';
import Highlighter from 'react-highlight-words';

import { HIGHLIGHT_PROPS } from 'components/company/CompanyTable/CompanyName/constants';
import useQuery from 'hooks/useQuery';
import useSearchWords from 'hooks/useSearchWords';

export interface CompanyContactProps {
  name?: string;
  email?: string;
  phone?: string;
}

const CompanyContact: FunctionComponent<CompanyContactProps> = function ({
  name = '',
  email = '',
  phone = '',
}) {
  const [query] = useQuery('companies');
  const searchWords = useSearchWords(query);

  return (
    <div className="flex flex-col text-12-18 text-neutral-900">
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={name}
      />
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={email}
      />
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={phone}
      />
    </div>
  );
};

export default CompanyContact;
